import React from 'react'
import { Button } from 'antd'
import { useMigrateMbaVersionMutation } from '../../../../store/apis/version.api'
import { openNotificationWithIcon } from '../../../../utils/notification.helper'

const MbaUpgradeActions = ({ token, versionId }) => {
    const [migrateMbaVersion, migrateMbaVersionResult] = useMigrateMbaVersionMutation()
    const handleUpgradeClick = async event => {
        event.stopPropagation()
        const response = await migrateMbaVersion({ token, versionId })

        'data' in response
            ? openNotificationWithIcon('success', 'Upgraded successfully')
            : openNotificationWithIcon('error', response.error)
    }

    return (
        <Button size='small' onClick={handleUpgradeClick} loading={migrateMbaVersionResult.isLoading}>
            Upgrade
        </Button>
    )
}

export default MbaUpgradeActions
